/** The entity card's fixed width. */
export const ENTITY_CARD_WIDTH = 240;

/**
 * Every card is the same height, so a row of cards reads as a row: 24px padding top and bottom, the
 * status row, the name, two lines of meta, the balance block and the 6px gaps between them. A card
 * without a balance (or with one meta line) keeps the space rather than shrinking.
 */
export const ENTITY_CARD_HEIGHT = 24 + 14 + 6 + 19 + 6 + 28 + 6 + 4 + 50 + 24;
